import React from 'react';
import './alertmodal.css';
import { truncateString } from '../global';
import { useState } from 'react';

const SeeMoreModal = ({ detail, maxLength }) => {
    const [showModal, setShowModal] = useState(false)


    window.onclick = function (event) {
        var modal = document.getElementById("myModal");
        if (event.target == modal) {
            setShowModal(false)
        }
    }

    const onFirstClick = () => {
        setShowModal(false)
    }

    return (<>
            {showModal && 
                <div id="myModal" className="modal">
                    <div className="modal-content" style={{ width: '60%'}}>
                        <div style={{ fontSize: '14px' }}>{detail && detail}</div>
                    </div>
                </div> } 
                        
            <div>{detail && truncateString(detail, maxLength)} {detail && detail.length > maxLength &&  <span className="seemore" onClick={() => setShowModal(true)}>see more...</span>}</div>
    
    </>) 
}

export default SeeMoreModal;